import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    SlaCalculateMinDeliveryDateParams,
    SlaCalculateMinDeliveryDateResponse,
    SlaCreatePayloadT,
    SlaCreateResponseT,
    SlaDeleteResponseT,
    SlaExportExcelParams,
    SlaGetListParams,
    SlaGetListResponseT,
    SlaUpdateResponseT,
} from '../types/sla.types'

export class SlaRepository {
    getList(params: SlaGetListParams): Promise<AxiosResponse<SlaGetListResponseT>> {
        return http.get('/location/api/slas', { params })
    }

    getListFtl(payload: SlaGetListParams): Promise<AxiosResponse<SlaGetListResponseT>> {
        const params = {
            ...payload,
            isExtended: 0,
        }
        return http.get('/location/api/ftl/slas', { params })
    }

    createSLA(sla_payload: SlaCreatePayloadT): Promise<AxiosResponse<SlaCreateResponseT>> {
        return http.post('/location/api/slas', sla_payload)
    }

    createSlaFtl(sla_payload: SlaCreatePayloadT): Promise<AxiosResponse<SlaCreateResponseT>> {
        return http.post('/location/api/ftl/slas', sla_payload)
    }

    updateSLA(
        sla_id: number,
        sla_payload: SlaCreatePayloadT
    ): Promise<AxiosResponse<SlaUpdateResponseT>> {
        return http.put(`/location/api/slas/${sla_id}`, sla_payload)
    }

    updateSlaFtl(
        sla_id: number,
        sla_payload: SlaCreatePayloadT
    ): Promise<AxiosResponse<SlaUpdateResponseT>> {
        return http.put(`/location/api/ftl/slas/${sla_id}`, sla_payload)
    }

    deleteSLA(sla_id: number): Promise<AxiosResponse<SlaDeleteResponseT>> {
        return http.delete(`/location/api/slas/${sla_id}`)
    }

    deleteSlaFtl(sla_id: number): Promise<AxiosResponse<SlaDeleteResponseT>> {
        return http.delete(`/location/api/ftl/slas/${sla_id}`)
    }

    importFromExcel(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/location/api/slas/import', form_data)
    }

    exportExcel(params: SlaExportExcelParams): Promise<AxiosResponse<any>> {
        return http.get('/location/api/slas/export', {
            responseType: 'blob',
            params,
        })
    }

    calculateMinDeliveryDate(params: SlaCalculateMinDeliveryDateParams): Promise<AxiosResponse<SlaCalculateMinDeliveryDateResponse>> {
        return http.get('/location/api/slas/calculate', { params })
    }
}
